import { render, staticRenderFns } from "./index.html?vue&type=template&id=616d0827&scoped=true&external"
import script from "./XacMinh.vue?vue&type=script&lang=js"
export * from "./XacMinh.vue?vue&type=script&lang=js"
import style0 from "./XacMinh.vue?vue&type=style&index=0&id=616d0827&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616d0827",
  null
  
)

export default component.exports